import { render, staticRenderFns } from "./UnsubscribeDialog.vue?vue&type=template&id=f7cd57ea&"
import script from "./UnsubscribeDialog.vue?vue&type=script&lang=ts&"
export * from "./UnsubscribeDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
